<div class="modal-wrapper" [class.transparent-background]="transparentBackground" #wrapper>
  <div class="modal-background"></div>
  <div
    [@modal2]="'opened'"
    role="dialog"
    class="modal-container"
    trap-focus
    [ngClass]="[gridSize, heightClass]"
    #container
    (click)="stopEvent($event)"
  >
    <div *ngIf="showXButton" class="select-button close" (click)="close()"><i class="insight-icon-close"></i></div>
    <div class="focus" tabindex="-1"></div>
    <ng-content> </ng-content>
  </div>
</div>
